import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import IntegrationHooks from './IntegrationHooks.vue';
import Index from './Index.vue';
import Webhook from './Webhooks/Index.vue';
import DashboardApps from './DashboardApps/Index.vue';
import Slack from './Slack.vue';
import SettingsContent from '../Wrapper.vue';
import Linear from './Linear.vue';
import Shopify from './Shopify.vue';
import McpServersList from 'dashboard/components-next/Settings/McpServers/McpServersList.vue';
import McpServersPageRouteView from './McpServers/McpServersPageRouteView.vue';
import DrivesList from './Drives/Index.vue';
import DriveProviderIndex from './Drives/ProviderIndex.vue';
import DrivesPageRouteView from './Drives/DrivesPageRouteView.vue';
import CalendarsList from './Calendars/Index.vue';
import CalendarsPageRouteView from './Calendars/CalendarsPageRouteView.vue';
import TeamleaderList from './Teamleader/Index.vue';
import TeamleaderPageRouteView from './Teamleader/TeamleaderPageRouteView.vue';
import HubspotList from './Hubspot/Index.vue';
import HubspotPageRouteView from './Hubspot/HubspotPageRouteView.vue';
import MetaConversionsList from './MetaConversions/Index.vue';
import MetaConversionsPageRouteView from './MetaConversions/MetaConversionsPageRouteView.vue';
import GoogleAdsList from './GoogleAds/Index.vue';
import GoogleAdsPageRouteView from './GoogleAds/GoogleAdsPageRouteView.vue';
import OdooList from './Odoo/Index.vue';
import OdooPageRouteView from './Odoo/OdooPageRouteView.vue';
import OpenAIList from './OpenAI/Index.vue';
import OpenAIPageRouteView from './OpenAI/OpenAIPageRouteView.vue';
import GoogleTranslateList from './GoogleTranslate/Index.vue';
import GoogleTranslatePageRouteView from './GoogleTranslate/GoogleTranslatePageRouteView.vue';
import Notion from './Notion.vue';
import RestaurantWidgetsList from './RestaurantWidgets/Index.vue';
import RestaurantWidgetProviderIndex from './RestaurantWidgets/ProviderIndex.vue';
import RestaurantWidgetsPageRouteView from './RestaurantWidgets/RestaurantWidgetsPageRouteView.vue';
import OAuthApplications from './OAuthApplications/Index.vue';
import OAuthApplicationsPageRouteView from './OAuthApplications/OAuthApplicationsPageRouteView.vue';
import DashboardAppsPageRouteView from './DashboardApps/DashboardAppsPageRouteView.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/integrations'),
      component: SettingsWrapper,
      props: {},
      children: [
        {
          path: '',
          name: 'settings_applications',
          component: Index,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
          },
        },
        {
          path: 'webhook',
          component: Webhook,
          name: 'settings_integrations_webhook',
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
          },
        },
      ],
    },
    // Dedicated Index-linked pages MUST be registered before the :integration_id catch-all.
    {
      path: frontendURL(
        'accounts/:accountId/settings/integrations/mcp_servers'
      ),
      component: McpServersPageRouteView,
      children: [
        {
          path: '',
          name: 'settings_integrations_mcp_servers',
          component: McpServersList,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/integrations/drives'),
      component: DrivesPageRouteView,
      children: [
        {
          path: '',
          name: 'settings_integrations_drives',
          component: DrivesList,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'explorer',
          name: 'settings_integrations_drives_explorer',
          component: () => import('./Drives/FileExplorer.vue'),
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'picker',
          name: 'settings_integrations_drives_picker',
          component: () => import('./Drives/PickerPopup.vue'),
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: ':provider',
          name: 'settings_integrations_drives_provider',
          component: DriveProviderIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/integrations/calendars'),
      component: CalendarsPageRouteView,
      children: [
        {
          path: '',
          name: 'settings_integrations_calendars',
          component: CalendarsList,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/integrations/teamleader'),
      component: TeamleaderPageRouteView,
      children: [
        {
          path: '',
          name: 'settings_integrations_teamleader',
          component: TeamleaderList,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/integrations/hubspot'),
      component: HubspotPageRouteView,
      children: [
        {
          path: '',
          name: 'settings_integrations_hubspot',
          component: HubspotList,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/integrations/meta_conversions'
      ),
      component: MetaConversionsPageRouteView,
      children: [
        {
          path: '',
          name: 'settings_integrations_meta_conversions',
          component: MetaConversionsList,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/integrations/google_ads'),
      component: GoogleAdsPageRouteView,
      children: [
        {
          path: '',
          name: 'settings_integrations_google_ads',
          component: GoogleAdsList,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/integrations/odoo'),
      component: OdooPageRouteView,
      children: [
        {
          path: '',
          name: 'settings_integrations_odoo',
          component: OdooList,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/integrations/openai'),
      component: OpenAIPageRouteView,
      children: [
        {
          path: '',
          name: 'settings_integrations_openai',
          component: OpenAIList,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/integrations/google_translate'
      ),
      component: GoogleTranslatePageRouteView,
      children: [
        {
          path: '',
          name: 'settings_integrations_google_translate',
          component: GoogleTranslateList,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/integrations/oauth_applications'
      ),
      component: OAuthApplicationsPageRouteView,
      children: [
        {
          path: '',
          name: 'settings_integrations_oauth_applications',
          component: OAuthApplications,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/integrations/dashboard_apps'
      ),
      component: DashboardAppsPageRouteView,
      children: [
        {
          path: '',
          name: 'settings_integrations_dashboard_apps',
          component: DashboardApps,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/integrations/restaurant_widgets'
      ),
      component: RestaurantWidgetsPageRouteView,
      children: [
        {
          path: '',
          name: 'settings_integrations_restaurant_widgets',
          component: RestaurantWidgetsList,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: ':provider',
          name: 'settings_integrations_restaurant_widgets_provider',
          component: RestaurantWidgetProviderIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/integrations'),
      component: SettingsContent,
      props: params => {
        const integrationId = params.params?.integration_id;
        const hideHeader = ['dialogflow'].includes(integrationId);

        // Don't show header
        if (hideHeader) {
          return {};
        }

        const showBackButton = params.name !== 'settings_integrations';
        const backUrl =
          params.name === 'settings_integrations_integration'
            ? { name: 'settings_integrations' }
            : '';
        return {
          headerTitle: 'INTEGRATION_SETTINGS.HEADER',
          icon: 'flash-on',
          showBackButton,
          backUrl,
        };
      },
      children: [
        {
          path: 'slack',
          name: 'settings_integrations_slack',
          component: Slack,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
          },
          props: route => ({ code: route.query.code }),
        },
        {
          path: 'linear',
          name: 'settings_integrations_linear',
          component: Linear,
          meta: {
            permissions: ['administrator'],
          },
          props: route => ({ code: route.query.code }),
        },
        {
          path: 'notion',
          name: 'settings_integrations_notion',
          component: Notion,
          meta: {
            permissions: ['administrator'],
          },
          props: route => ({ code: route.query.code }),
        },
        {
          path: 'shopify',
          name: 'settings_integrations_shopify',
          component: Shopify,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
          },
          props: route => ({ error: route.query.error }),
        },
        {
          path: ':integration_id',
          name: 'settings_applications_integration',
          component: IntegrationHooks,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
          },
          props: route => ({
            integrationId: route.params.integration_id,
          }),
        },
      ],
    },
  ],
};
